const API_BASE_URL = 'https://api.protektor-polska.pl:5000';  //http://85.255.5.121:5000/api/auth/ //http://localhost:5000/api/auth/ //https://api.protektor-polska.pl:5000

const API_URL = `${API_BASE_URL}/api/`;
const API_AUTH_URL = `${API_BASE_URL}/api/auth/`;

export { API_BASE_URL, API_URL, API_AUTH_URL };
